<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 15.18 15.18"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          class="cls-1"
          x="3.06"
          y="3.81"
          width="9.07"
          height="7.56"
          transform="translate(-3.14 7.77) rotate(-45.97)"
        />
      </clipPath>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_28159" data-name="Group 28159">
          <g id="Ellipse_479" data-name="Ellipse 479">
            <circle class="cls-2" cx="7.59" cy="7.59" r="7.59" />
            <circle class="cls-3" cx="7.59" cy="7.59" r="7.09" />
          </g>
          <g id="Group_28158" data-name="Group 28158">
            <g class="cls-4">
              <g id="Group_28158-2" data-name="Group 28158-2">
                <path
                  id="Path_16090"
                  data-name="Path 16090"
                  class="cls-5"
                  d="M8.33,10.3A.31.31,0,0,0,8,10.23a2.23,2.23,0,1,1-.08-4.17l-.82.85a.32.32,0,0,0,0,.46.51.51,0,0,0,.18.09l3.65.59a.33.33,0,0,0,.37-.27.28.28,0,0,0,0-.13l-.82-3.52a.32.32,0,0,0-.39-.24A.26.26,0,0,0,9.92,4l-.64.66a.34.34,0,0,1-.38.07A3.86,3.86,0,0,0,3.71,6.43a4,4,0,0,0-.37,1.21,3.8,3.8,0,0,0,1.31,3.42A3.9,3.9,0,0,0,9,11.54a.31.31,0,0,0,.13-.43A.24.24,0,0,0,9.08,11Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1,
.cls-3 {
  fill: none;
}
.cls-2 {
  fill: #fff;
}
.cls-3 {
  stroke: #0064ff;
}
.cls-4 {
  clip-path: url(#clip-path);
}
.cls-5 {
  fill: #0064ff;
}
</style>
